export type AttemptOutcome = {
  symptomResolved: boolean;
  newSignal: string | null;
  success: boolean;
};

export function determineAttemptOutcome(
  lastAction: string | undefined,
  unlockedClueCount: number
): AttemptOutcome {
  if (!lastAction) return { symptomResolved: false, newSignal: null, success: false };

  const action = lastAction.toLowerCase();

  const enrichment =
    /speelgoed|rustig|hoek|omgeving|verplaats|calm|toy|quiet/.test(action);

  const strongerStructure =
    /nieuwe kooi|sterker|slot|vergrendel|strong|lock/.test(action);

  if (enrichment) {
    return { symptomResolved: true, newSignal: null, success: true };
  }

  if (strongerStructure && unlockedClueCount === 0) {
    return { symptomResolved: true, newSignal: "restlessness", success: false };
  }

  if (unlockedClueCount === 0) {
    return { symptomResolved: false, newSignal: "misaligned", success: false };
  }

  return { symptomResolved: false, newSignal: "partial", success: false };
}